const strings = {
  title: 'Dados Agricultor',
  document: 'CPF/CNPJ',
  email: 'Email',
  celular: 'Celular',
  situacao: 'Situacao',
}

export default strings
